import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=a279a52c&scoped=true&"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=a279a52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a279a52c",
  null
  
)

export default component.exports